import { CSSProperties } from 'react';
import { IBanner } from 'mod/featureV2/interface/banner';
import { getModuleCode } from 'mod/featureV2/utils';
import { ITrackerData } from '@base/lib/Tracker';
import { isVideoUrl } from 'base/utils/file';
import { IBannerProps } from 'mod/featureV2/Banner/interface';
import { get375CssValue } from 'base/utils/dom-size';

export function forceVideoAsGif<T extends IBanner>(banner: T): T {
    if (!isVideoUrl(banner.src)) {
        return banner;
    }
    return {
        ...banner,
        autoPlay: true,
        control: false,
        controls: false,
        loop: 'loop' in banner ? banner.loop : true,
    }
}

export function getBannerTrackData(moduleId: string | undefined, banner: IBanner, index: number): ITrackerData | undefined {
    if (!moduleId) {
        return void 0;
    }
    return {
        targetType: 'banner',
        target: banner.src,
        relTarget: banner.src,
        module: getModuleCode(moduleId),
        position: index + 1,
        creative: banner.src,
    }
}

export function getBannerStyle(bannerProps: IBannerProps<IBanner & Record<string, any>>): CSSProperties {
    const style: CSSProperties = {};
    const { radius } = bannerProps;
    if (typeof radius === 'number' && radius > 0) {
        style.borderRadius = get375CssValue(radius);
        style.overflow = 'hidden';
    } else if (typeof radius === 'string') {
        style.borderRadius = radius;
        style.overflow = 'hidden';
    }
    return style
}